import { Box } from "@mui/material";
import { FileText, Search, FolderTree } from "lucide-react";
import { t } from "i18next";

interface FileTypeBadgeProps {
  type: "분석" | "검사" | "분류";
  size?: "sm" | "md";
}

export const badgeConfig = {
  분석: {
    key: "analysis",
    icon: FileText,
    labelKey: "Analysis",
  },
  검사: {
    key: "inspection",
    icon: Search,
    labelKey: "Inspection",
  },
  분류: {
    key: "classification",
    icon: FolderTree,
    labelKey: "Classification",
  },
} as const;

export function FileTypeBadge({ type, size = "md" }: FileTypeBadgeProps) {
  const badge = badgeConfig[type];

  return (
    <Box
      sx={{
        backgroundColor: `var(--badge-${badge.key}-bg)`,
        color: `var(--badge-${badge.key}-text)`,
        border: "1px solid",
        borderColor: `var(--badge-${badge.key}-border)`,
        px: 1.5,
        py: 0.5,
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        fontWeight: 600,
        fontSize: 12,
      }}
    >
      <badge.icon size={14} />
      {t(badge.labelKey)}
    </Box>
  );
}
